import Vue from 'vue'
import { initializeApp } from 'firebase/app'
import { getMessaging, getToken, deleteToken, onMessage, isSupported } from 'firebase/messaging'

const firebaseConfig = {
    apiKey: 'AIzaSyBeoillAiWXoya02Uji6P8aFu-Jh5PbShw',
    authDomain: 'halogen-emblem-191119.firebaseapp.com',
    projectId: 'halogen-emblem-191119',
    storageBucket: 'halogen-emblem-191119.appspot.com',
    databaseURL: 'https://halogen-emblem-191119-default-rtdb.europe-west1.firebasedatabase.app',
    messagingSenderId: '153218582821',
    appId: '1:153218582821:web:4c66e3b544d7beebf572cc',
    measurementId: 'G-9QTH7ENQLY',
}
try {
    isSupported().then((messagingSupported) => {
        if (messagingSupported) {
            initializeApp(firebaseConfig)
            Vue.prototype.$messaging = getMessaging()
            Vue.prototype.$getToken = getToken
            Vue.prototype.$deleteToken = deleteToken
            Vue.prototype.$onMessage = onMessage
        }
        Vue.prototype.$isSupported = messagingSupported
    })
} catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`Firebase error: ${e}`)
}
